//==============================
// Global
//==============================

FastClick.attach(document.body);


var w = $(window);
var ww = w.width();
var wh = w.height();
var html = $('html');
var body = $('body');


$('.post-content, .intro, .split-content-item').fitVids();
